import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Game from "./Game";
import GameSequence from "./GameSequence";
import PrivacyPolicy from "./Privacy";
import About from "./About";
// import Switcher from './Switcher.jsx';



function App() {
  if (window.location.pathname === "/sedec-order" || window.location.pathname === "/sedec-order/about") {
    document.title = "Sedecorder - Daily"
  }
  if (window.location.pathname === "/sedec-order/practice" || window.location.pathname === "/sedec-order/practice/about") {
    document.title = "Sedecorder - Practice"
  }

  return (
      <>
      {/* <div className="hidden">
      <Switcher/>
      </div> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sedecordle" element={<Game />} />
        <Route path="/sedecordle/practice" element={<Game />} />
        <Route path="/sedec-order" element={<GameSequence />} />
        <Route path="/sedec-order/practice" element={<GameSequence />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/sedecordle/about" element={<About />} />
        <Route path="/sedec-order/about" element={<About />} />
        <Route path="/sedec-order/practice/about" element={<About />} />
      </Routes>
    </>
  );
}

export default App;